export const getPaceString = (car) => {
    // If not a golfer type of car then just return an empty string
    var result = "";
    if (car?.CarType === 1 || car?.CarType === 3) {
      //normal or handicap
      if (car?.Pace > 0) result = `${car?.Pace?.toString()} min ahead `;
      else if (car?.Pace < 0) result = `${(-car?.Pace).toString()} min behind `;
      else result = "on pace ";
      if (car?.HolesPlayed > 0)
        result = `${result} through ${car?.HolesPlayed?.toString()}`;
    }
    return result;
  };